<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{ $t('menu.tokushoho') }}</h3>

            <div class="textBox">
                <!-- block -->
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">項目</th>
                            <th scope="col">内容</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>事業者名称</td>
                            <td>Edu Tek Company Limited</td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>責任者氏名</td>
                            <td>髙田恵津子</td>
                        </tr>
                        <tr>
                            <th scope="row">3</th>
                            <td>所在地</td>
                            <td>Oliaji Trade Centre, 1<sup>st</sup> Floor, Victoria, Mahe, Seychelles</td>
                        </tr>
                        <tr>
                            <th scope="row">4</th>
                            <td>連絡先</td>
                            <td>inquiry@edutek.company</td>
                        </tr>
                        <tr>
                            <th scope="row">5</th>
                            <td>営業時間・休業日</td>
                            <td>9:30~17:30（土日祝日を除く）</td>
                        </tr>
                        <tr>
                            <th scope="row">6</th>
                            <td>販売価格</td>
                            <td>AUBEサイト内の商品ごとに記載されている価格を参照ください。</td>
                        </tr>
                        <tr>
                            <th scope="row">7</th>
                            <td>販売価格以外の費用</td>
                            <td>電気通信回線の通信料金（インターネット接続料金を含む）
（お客様がご利用のインターネットプロバイダーなどにお問い合わせください）</td>
                        </tr>
                        <tr>
                            <th scope="row">8</th>
                            <td>代金の支払時期</td>
                            <td>コンテンツまたは商品提供前</td>
                        </tr>
                        <tr>
                            <th scope="row">9</th>
                            <td>代金の支払方法</td>
                            <td>HEC(Hermes Edu coin)</td>
                        </tr>
                        <tr>
                            <th scope="row">10</th>
                            <td>商品の引渡時期</td>
                            <td>お支払手続き完了後</td>
                        </tr>
                        <tr>
                            <th scope="row">11</th>
                            <td>返品について</td>
                            <td>コンテンツまたは商品の返品および交換はできません。</td>
                        </tr>
                        <tr>
                            <th scope="row">12</th>
                            <td>本サービスを利用可能な動作環境</td>
                            <td>別途ファイルで添付</td>
                        </tr>
                        <tr>
                            <th scope="row">13</th>
                            <td>利用条件</td>
                            <td>AUBEサイト内の利用規約に記載</td>
                        </tr>
                    </tbody>
                </table>

                <h4 class="my-3">本サービスを利用可能な動作環境</h4>
                <div class="text-center mt-2 a tokushoho_version_info_parent">
                        <div class="version_info">
                            <div>▼PCの場合</div><!--既存のこのページの内容が日英で切り替わらないので、それに合わせて切り替わる部分を日本語で固定-->
                            <table class="faq_pc">
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <th>{{ $t('faq.box6.q1.pc.tr1.th1') }}</th>
                                        <th>{{ $t('faq.box6.q1.pc.tr1.th2') }}</th>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('faq.box6.q1.pc.tr2.td1') }}</td>
                                        <td>{{ $t('faq.box6.q1.pc.tr2.td2') }}</td>
                                        <td>{{ $t('faq.box6.q1.pc.tr2.td3') }}</td>
                                    </tr>
                                    <tr>
                                        <td>ブラウザ</td><!--既存のこのページの内容が日英で切り替わらないので、それに合わせて切り替わる部分を日本語で固定-->
                                        <td>
                                            {{ $t('faq.box6.q1.pc.tr3.td2.1') }}<br>
                                            {{ $t('faq.box6.q1.pc.tr3.td2.2') }}<br>
                                            {{ $t('faq.box6.q1.pc.tr3.td2.3') }}
                                        </td>
                                        <td>
                                            {{ $t('faq.box6.q1.pc.tr3.td3.1') }}<br>
                                            {{ $t('faq.box6.q1.pc.tr3.td3.2') }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div>▼スマートフォン / タブレットの場合</div><!--既存のこのページの内容が日英で切り替わらないので、それに合わせて切り替わる部分を日本語で固定-->
                            <table class="faq_sp">
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <th>{{ $t('faq.box6.q1.sp.tr1.th1') }}</th>
                                        <th>{{ $t('faq.box6.q1.sp.tr1.th2') }}</th>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('faq.box6.q1.sp.tr2.td1') }}</td>
                                        <td>
                                            {{ $t('faq.box6.q1.sp.tr2.td2.1') }} <br>
                                            {{ $t('faq.box6.q1.sp.tr2.td2.2') }} <br>
                                            {{ $t('faq.box6.q1.sp.tr2.td2.3') }} <br>
                                            {{ $t('faq.box6.q1.sp.tr2.td2.4') }} <br>
                                            {{ $t('faq.box6.q1.sp.tr2.td2.5') }} 
                                        </td>
                                        <td>
                                            {{ $t('faq.box6.q1.sp.tr2.td3.1') }} <br>
                                            {{ $t('faq.box6.q1.sp.tr2.td3.2') }} <br>
                                            {{ $t('faq.box6.q1.sp.tr2.td3.3') }} <br>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>ブラウザ</td><!--既存のこのページの内容が日英で切り替わらないので、それに合わせて切り替わる部分を日本語で固定-->
                                        <td>
                                            {{ $t('faq.box6.q1.sp.tr3.td2') }}
                                        </td>
                                        <td>
                                            {{ $t('faq.box6.q1.sp.tr3.td3.1') }}<br>
                                            {{ $t('faq.box6.q1.sp.tr3.td3.2') }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                
                <!-- enactment date -->
                <p class="mt-5">
                    {{ $t('outline.enactment_date', {
                        y: 2020,
                        m: 9,
                        M: 'September',
                        d: 1,
                    }) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'tokushoho',

        components: {
        },

        mounted() {
        }
    }
</script>

<style>
    @media only screen and (max-width: 991px) {
        .pl-4, .px-4 {
            padding-left: 1rem !important;
        }
    }
    .underline {
        text-decoration: underline;
    }

    /*対応バージョン一覧表示用スタイルは、FAQ.vueに書かれているスタイルがこのファイルにも適用されるのでそちらを参照
    ここにはFAQ.vueとHTMLの構成が異なり、適用されないスタイルがあるので、その分を記載*/
    .tokushoho_version_info_parent{
        padding: 30px 40px;
        font-size: 18px;
        color: #451493;
        background-color: #fff;
        max-width: 771px;
    }
    @media screen and (max-width: 991px){
    .tokushoho_version_info_parent{
        padding: 17px 14px;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
    }
}
</style>
